import border from '../../border';

const secondary = (params) => border.hover.secondary(params);

export default secondary;
